import { render } from "./Filters.vue?vue&type=template&id=2f00797c&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=2f00797c&lang=scss"
import "./Filters.vue?vue&type=style&index=1&id=2f00797c&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f00797c"]])

export default __exports__